import Cookies from 'js-cookie'

const feature = {
  state: {
    dateType: Cookies.get('accounting_dateType') ? Cookies.get('accounting_dateType') : 'year',
    categoryId: Cookies.get('accounting_categoryId') ? Cookies.get('accounting_categoryId') : '',
    dates: Cookies.get('accounting_dates') ? Cookies.get('accounting_dates') : '',
    search: Cookies.get('accounting_search') ? Cookies.get('accounting_search') : '',
    graphExpand: Cookies.get('accounting_graphExpand') ? Cookies.get('accounting_graphExpand') : '',
  },
  getters: {
    dateType: state => state.dateType,
    categoryId: state => state.categoryId,
    dates: state => state.dates,
    search: state => state.search,
    graphExpand: state => state.graphExpand
  },
  mutations: {
    SET_ACCOUNTING_DATE_TYPE: (state, dateType) => {
      state.dateType = dateType
    },
    SET_ACCOUNTING_CATEGORY_ID: (state, categoryId) => {
      state.categoryId = categoryId
    },
    SET_ACCOUNTING_DATES: (state, dates) => {
      state.dates = dates
    },
    SET_ACCOUNTING_SEARCH: (state, search) => {
      state.search = search
    },
    SET_ACCOUNTING_GRAPH_EXPAND: (state, graphExpand) => {
      state.graphExpand = graphExpand
    },
  },
  actions: {
    SetAccountingDateType({ commit }, dateType) {
      Cookies.set('accounting_dateType', dateType)
      // console.log("dateType", dateType)
      commit('SET_ACCOUNTING_DATE_TYPE', dateType)
    },
    SetAccountingCategoryId({ commit }, categoryId) {
      Cookies.set('accounting_categoryId', categoryId)
      commit('SET_ACCOUNTING_CATEGORY_ID', categoryId)
    },
    SetAccountingDates({ commit }, dates) {
      Cookies.set('accounting_dates', dates)
      // console.log("accounting_dates", dates)
      commit('SET_ACCOUNTING_DATES', dates)
    },
    SetAccountingSearch({ commit }, search) {
      Cookies.set('accounting_search', search)
      commit('SET_ACCOUNTING_SEARCH', search)
    },
    SetAccountingGraphExpand({ commit }, graphExpand) {
      Cookies.set('accounting_graphExpand', graphExpand)
      commit('SET_ACCOUNTING_GRAPH_EXPAND', graphExpand)
    },
  }
}

export default feature



// WEBPACK FOOTER //
// ./src/store/modules/accounting.js